import React, { lazy, Suspense, memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { App, ConfigProvider } from "antd";
import Loading from "components/shared-components/Loading";
import { lightTheme, darkTheme } from "configs/ThemeConfig";
import { resources } from "lang";
import useBodyClass from "utils/hooks/useBodyClass";
import Routes from "routes";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { authLoadedManually, getUserInfo } from "store/slices/authSlice";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

const Layouts = () => {
  const { token, user, authLoaded } = useSelector((state) => state.auth);
  const blankLayout = useSelector((state) => state.theme.blankLayout);

  const dispatch = useDispatch();

  const Layout = token && !blankLayout ? AppLayout : AuthLayout;

  const locale = useSelector((state) => state.theme.locale);

  const direction = useSelector((state) => state.theme.direction);

  const currentTheme = useSelector((state) => state.theme.currentTheme);

  const currentAppLocale = resources[locale];

  useBodyClass(`dir-${direction}`);

  const themeConfig =
    currentTheme === "light" ? { ...lightTheme } : { ...darkTheme };

  useEffect(() => {
    const storedToken = localStorage.getItem(AUTH_TOKEN);

    if (storedToken && !user) {
      dispatch(getUserInfo());
    } else if (!storedToken) {
      dispatch(authLoadedManually());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!authLoaded) {
    return <Loading cover="content" />;
  }

  return (
    <ConfigProvider
      theme={themeConfig}
      direction={direction}
      locale={currentAppLocale.antd}
    >
      <App>
        <Suspense fallback={<Loading cover="content" />}>
          <Layout>
            <Routes />
          </Layout>
        </Suspense>
      </App>
    </ConfigProvider>
  );
};

export default memo(Layouts);
